import { images } from ".";

const events = [ 
    {
        id: 1,
        image: images.event1,
        title: "Luxury Car Expo 2025",
        content: "Explore the latest luxury car rental trends.",
        featuredCarIds: [10, 13, 22, 5],
        details: {
            date: "April 10, 2025", 
            time: "03:00 PM - 06:00 PM",
            location: "Las Vegas, NV",
            organizer: "Industry Expert",
            number: "+123-456-7890",
            email: "info@autoshowcase.com",
            fee: "Free Admission",
        },
        paragraphs: [
            "Join us for an exclusive car rental showcase, featuring a premium collection of luxury, sports, and SUV rentals. Experience firsthand the latest car models, test drives, and unbeatable rental deals.",
            "Our expert team will be available to assist with personalized rental options, exclusive discounts, and on-the-spot bookings for your next adventure or business trip."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2,
        ],
        highlights: [
            "Test drive premium rental cars",
            "Exclusive event-only discounts",
            "Meet industry experts & consultants",
            "On-the-spot car rental bookings",
            "Luxury & economy rental options available"
        ],
        participation: [
            "Register for free entry",
            "Explore various rental cars",
            "Book a test drive",
            "Enjoy exclusive rental deals",
            "Plan your next trip with ease"
        ],
    },
    {
        id: 2,
        image: images.event2,
        title: "Road Trip Rental Fair 2025",
        content: "Find the best deals for long-distance rentals.",
        featuredCarIds: [3, 11, 20],
        details: {
            date: "May 5, 2025", 
            time: "01:00 PM - 03:00 PM",
            location: "Los Angeles, CA",
            organizer: "Rental Experts",
            number: "+123-456-7890",
            email: "info@rentalfair.com",
            fee: "Free Admission",
        },
        paragraphs: [
            "Join us for an exclusive road trip rental fair, featuring top deals on long-distance car rentals. Discover the best options for comfortable and budget-friendly travel across the country.",
            "Our team of experts will guide you through rental options, special discounts, and on-the-spot bookings to help you plan your next adventure with ease."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2,
        ],
        highlights: [
            "Exclusive long-distance rental discounts",
            "Meet rental industry professionals",
            "On-the-spot car rental bookings",
            "Wide selection of road trip-friendly vehicles",
            "Travel planning tips & advice"
        ],
        participation: [
            "Register for free entry",
            "Explore the best rental deals",
            "Compare road trip vehicle options",
            "Enjoy special event discounts",
            "Plan your next road trip hassle-free"
        ],
    },
    {
        id: 3,
        image: images.event3,
        title: "EV Car Rental Summit 2025",
        content: "Discuss the future of electric vehicle rentals.",
        featuredCarIds: [4],
        details: {
            date: "June 18, 2025", 
            time: "10:00 AM - 11:00 AM",
            location: "San Francisco, CA",
            organizer: "EV Rental Experts",
            number: "+123-456-7890",
            email: "info@evsummit.com",
            fee: "Free Admission",
        },
        paragraphs: [
            "Join industry leaders, experts, and enthusiasts at the EV Car Rental Summit 2025 to explore the future of electric vehicle rentals. Discover the latest EV models, sustainable rental solutions, and innovative technologies shaping the industry.",
            "Gain insights from top professionals on cost-effective EV rental options, infrastructure developments, and exclusive rental deals available at the event."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2,
        ],
        highlights: [
            "Explore the latest EV rental options",
            "Meet industry experts & innovators",
            "Exclusive event-only rental discounts",
            "Discuss sustainability in car rentals",
            "On-the-spot EV rental bookings"
        ],
        participation: [
            "Register for free entry",
            "Learn about EV rental benefits",
            "Discover affordable long-term EV rentals",
            "Network with industry professionals",
            "Plan your next eco-friendly trip"
        ],
    },
    {
        id: 4,
        image: images.event4,
        title: "Rental Business Conference 2025",
        content: "Learn how to grow your rental business.",
        featuredCarIds: [2, 15],
        details: {
            date: "July 8, 2025", 
            time: "09:00 AM - 11:30 AM",
            location: "New York, NY",
            organizer: "Rental Industry Experts",
            number: "+123-456-7890",
            email: "info@rentalconference.com",
            fee: "Free Admission",
        },
        paragraphs: [
            "Join us at the Rental Business Conference 2025 to explore strategies for scaling your rental business, increasing revenue, and optimizing operations. Industry leaders and experts will share insights on the latest trends, digital transformation, and marketing techniques for rental businesses.",
            "Get exclusive access to expert-led workshops, networking opportunities, and special offers designed to help your rental business thrive in a competitive market."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2,
        ],
        highlights: [
            "Expert insights on rental business growth",
            "Marketing and digital strategies for rentals",
            "Exclusive industry networking opportunities",
            "Tips on maximizing rental profitability",
            "Innovative solutions for rental management"
        ],
        participation: [
            "Register for free entry",
            "Learn from industry leaders",
            "Discover new rental strategies",
            "Network with professionals",
            "Enhance your rental business success"
        ],
    },
    {
        id: 5,
        image: images.event5,
        title: "SUV Rental Showcase 2025",
        content: "Check out the best SUVs for rental fleets.",
        featuredCarIds: [3, 11, 20],
        details: {
            date: "August 15, 2025", 
            time: "02:00 PM - 05:00 PM",
            location: "Chicago, IL",
            organizer: "SUV Rental Experts",
            number: "+123-456-7890",
            email: "info@suvshowcase.com",
            fee: "Free Admission",
        },
        paragraphs: [
            "Join us at the SUV Rental Showcase 2025 to explore the latest and most in-demand SUVs for rental fleets. Discover the perfect balance of luxury, comfort, and performance to enhance your rental offerings.",
            "Industry professionals will provide insights on fleet management, cost-effective rental solutions, and exclusive deals on top SUV models available for rental businesses."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2,
        ],
        highlights: [
            "Showcase of top rental-friendly SUVs",
            "Exclusive event-only rental deals",
            "Meet fleet management experts",
            "Test drive the latest SUV models",
            "Learn about cost-effective SUV rentals"
        ],
        participation: [
            "Register for free entry",
            "Explore top SUV rental options",
            "Compare fleet-friendly SUV models",
            "Meet industry experts",
            "Find the best SUV rental deals"
        ],
    },
    {
        id: 6,
        image: images.event6,
        title: "Supercar Rental Experience 2025",
        content: "Test drive luxury sports cars available for rent.",
        featuredCarIds: [10, 13, 19, 22],
        details: {
            date: "September 20, 2025", 
            time: "09:00 PM - 10:30 PM",
            location: "Miami, FL",
            organizer: "Supercar Rental Experts",
            number: "+123-456-7890",
            email: "info@supercarshowcase.com",
            fee: "Free Admission",
        },
        paragraphs: [
            "Get ready for an unforgettable experience at the Supercar Rental Experience 2025. Test drive some of the most luxurious and high-performance sports cars available for rent. Feel the thrill of driving iconic supercars and explore exclusive rental options.",
            "Our experts will guide you through personalized rental choices, provide detailed insights on each model, and offer unbeatable deals for your next luxury rental experience."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2,
        ],
        highlights: [
            "Test drive world-class supercars",
            "Exclusive luxury rental options",
            "Meet supercar enthusiasts and experts",
            "Learn about high-performance rentals",
            "On-the-spot supercar rental bookings"
        ],
        participation: [
            "Register for free entry",
            "Experience the thrill of luxury cars",
            "Book a supercar test drive",
            "Get exclusive rental deals",
            "Drive your dream car today"
        ],
    }

];

export default events;